import { Outlet } from 'react-router-dom';

export function Main() {
    return (
        <main className="max-w-7xl mx-auto my-6 p-4 sm:my-8 sm:p-6 md:my-12 md:p-8">
             <Outlet /> {/* loads child routes defined in the router */}
        </main>
    );
}